/**
 * EMR Section ID constants
 * These IDs are used as keys in styleOverridesForPrintedEmrSections map
 */
export const EMR_SECTION_IDS = {
  HEALTH_COMPLAINTS: 'health_complaints',
  DIAGNOSIS: 'diagnosis',
  OBSERVATIONS: 'observations',
  DRUG_ADVICE: 'drug_advice',
  INVESTIGATIONS: 'investigations',
  ADVICE: 'advice',
  NEXT_VISIT_DETAILS: 'next_visit_details',
  THERAPY_RECOMMENDATION: 'therapy_recommendation',
  PAYMENT_AND_REFUND: 'payment_and_refund',
  JOINT_HOMUNCULUS: 'joint_homunculus',
  INSTRUCTIONS: 'instructions',
  PATIENT_VITALS: 'patient-vitals',
  SCREENING_REPORT: 'screening-report',
  PRIVATE_NOTES: 'private_notes',
  PSYCH_ASSESSMENTS: 'psych_assessments',
  REFER_TO: 'refer_to',
  PATIENT_HISTORY_NOTES: 'patient-history-notes',
  SCREENING_RECOMMENDATION: 'screening-recommendation',
  SIGNATURE: 'signature',
  FREE_FORM_RICH_TEXT: 'free_form_rich_text',
}
